import axios from 'axios';

const ENDPOINT = '/api/account/settings/reading-languages';

let cachedPreferences = null;
let pendingLoad = null;

function freezeEntries(entries) {
    return Object.freeze(
        (Array.isArray(entries) ? entries : []).map((entry) =>
            Object.freeze({
                code: entry.code,
                label: entry.label,
                ...(Object.prototype.hasOwnProperty.call(entry, 'removable') ? { removable: Boolean(entry.removable) } : {}),
            }),
        ),
    );
}

function canonicalize(payload, fallbackCatalog = []) {
    return Object.freeze({
        selected: freezeEntries(payload?.selected),
        catalog: freezeEntries(Array.isArray(payload?.catalog) ? payload.catalog : fallbackCatalog),
    });
}

const readingLanguagePreferences = Object.freeze({
    load({ force = false } = {}) {
        if (cachedPreferences && !force) {
            return Promise.resolve(cachedPreferences);
        }

        if (pendingLoad) {
            return pendingLoad;
        }

        pendingLoad = axios
            .get(ENDPOINT)
            .then((response) => {
                cachedPreferences = canonicalize(response.data);
                return cachedPreferences;
            })
            .finally(() => {
                pendingLoad = null;
            });

        return pendingLoad;
    },

    async save(languageCodes) {
        const response = await axios.put(ENDPOINT, {
            language_codes: languageCodes,
        });

        cachedPreferences = canonicalize(response.data, cachedPreferences?.catalog);
        return cachedPreferences;
    },

    peek() {
        return cachedPreferences;
    },

    clear() {
        cachedPreferences = null;
        pendingLoad = null;
    },
});

export default readingLanguagePreferences;
